// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface ModifyTwoFactorAuth {
  password: string
  twoFactorAuth: boolean
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate ModifyTwoFactorAuth request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateModifyTwoFactorAuth(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateModifyTwoFactorAuth(request: ModifyTwoFactorAuth): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.password === undefined || req.password === null) {
    errors.push({
      field: 'password',
      code: 'required',
      message: 'password is required'
    })
  }
  if (typeof req.password === 'string' && req.password.length > 64) {
    errors.push({
      field: 'password',
      code: 'too_long',
      message: 'password must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.password === 'string' && req.password.trim() === '') {
    errors.push({
      field: 'password',
      code: 'required',
      message: 'password cannot be empty'
    })
  }

  if (req.twoFactorAuth === undefined || req.twoFactorAuth === null) {
    errors.push({
      field: 'twoFactorAuth',
      code: 'required',
      message: 'twoFactorAuth is required'
    })
  }

  return errors
}

export const modifyTwoFactorAuth = postEndpoint<ModifyTwoFactorAuth, SimpleResponse>('/user/modifyTwoFactorAuth')
